import { render } from "./InstallationFiles.vue?vue&type=template&id=4f5fab84&scoped=true"
import script from "./InstallationFiles.vue?vue&type=script&lang=js"
export * from "./InstallationFiles.vue?vue&type=script&lang=js"

import "./InstallationFiles.vue?vue&type=style&index=0&id=4f5fab84&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5fab84"]])

export default __exports__